import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Dots } from "../Loader/loader";
import { fullName } from "../../utils/fullName";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const PLACE_TYPES = {
  schools: "Դպրոցներ",
  clubs: "Ակումբներ",
  federation: "Մարզային ֆեդերացիա",
};

// Organization/school dropdown; once one is chosen its address and trainers are shown.
// Used by both the registration form and the account settings.
const PlaceTrainerSelect = ({ placeId, trainerId, onChange, errors = {} }) => {
  const [places, setPlaces] = useState([]);
  const [trainers, setTrainers] = useState([]);
  const [trainersLoading, setTrainersLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/places/options`)
      .then((res) => setPlaces(res.data))
      .catch(() => setLoadError(true));
  }, []);

  useEffect(() => {
    setTrainers([]);
    if (!placeId) return undefined;
    let cancelled = false;
    setTrainersLoading(true);
    axios
      .get(`${API_BASE_URL}/api/places/${placeId}/trainers`)
      .then((res) => !cancelled && setTrainers(res.data))
      .catch(() => !cancelled && setTrainers([]))
      .finally(() => !cancelled && setTrainersLoading(false));
    return () => {
      cancelled = true;
    };
  }, [placeId]);

  const selectedPlace = useMemo(
    () => places.find((p) => String(p.id) === String(placeId)),
    [places, placeId]
  );

  const groupedPlaces = useMemo(
    () =>
      Object.keys(PLACE_TYPES)
        .map((type) => ({ type, items: places.filter((p) => p.type === type) }))
        .filter((g) => g.items.length),
    [places]
  );

  return (
    <>
      <div className={`auth-field${errors.place_id ? " invalid" : ""}`}>
        <label htmlFor="place_id">Կազմակերպություն / Դպրոց</label>
        <select
          id="place_id"
          value={placeId}
          onChange={(e) => onChange({ place_id: e.target.value, trainer_id: "" })}
        >
          <option value="">Ընտրեք կազմակերպությունը</option>
          {groupedPlaces.map((group) => (
            <optgroup key={group.type} label={PLACE_TYPES[group.type]}>
              {group.items.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
        {loadError && <span className="auth-error">Չհաջողվեց բեռնել կազմակերպությունների ցանկը։</span>}
        {errors.place_id && <span className="auth-error">{errors.place_id[0]}</span>}
      </div>

      {selectedPlace && (
        <>
          {selectedPlace.location && (
            <div className="org-address">
              <strong>Հասցե՝ </strong>
              {selectedPlace.location}
            </div>
          )}
          <div className={`auth-field${errors.trainer_id ? " invalid" : ""}`}>
            <span className="auth-label">Մարզիչներ</span>
            {trainersLoading && <Dots />}
            {!trainersLoading && trainers.length === 0 && (
              <span className="auth-muted">Այս կազմակերպությունում մարզիչներ դեռ չկան։</span>
            )}
            <div className="trainer-grid">
              {trainers.map((t) => (
                <label
                  key={t.id}
                  className={`trainer-card${String(trainerId) === String(t.id) ? " selected" : ""}`}
                >
                  <input
                    type="radio"
                    name="trainer_id"
                    value={t.id}
                    checked={String(trainerId) === String(t.id)}
                    onChange={() => onChange({ trainer_id: String(t.id) })}
                  />
                  <img src={t.image_url} alt={fullName(t)} />
                  <span>
                    {fullName(t)}
                  </span>
                </label>
              ))}
            </div>
            {errors.trainer_id && <span className="auth-error">{errors.trainer_id[0]}</span>}
          </div>
        </>
      )}
    </>
  );
};

export default PlaceTrainerSelect;
